var securus_shop_id = 'sheetmusic';

/*
function securusBookendStart() {
  try {
    BEObj.setOption({
      ins_app_name: "★カスタムアプリ名",
      url_ins_ios : "https://apps.apple.com/jp/app/★/idXXXXXXXXXX?itsct=apps_box&itscg=30200",
      url_ins_and : "https://play.google.com/store/apps/details?id=jp.★.app",
      url_ins_win : "★Windows版アプリのダウンロードURL(bookend契約内容により中継サーバ or bookendサーバとなる)",
      url_ins_mac : "★Mac版アプリのダウンロードURL(bookend契約内容により中継サーバ or bookendサーバとなる)",
    });
    
    BEObj.startBookendClient({
      CustomScheme:true,
      CustomName : "★bookendアカウント名(OwnerLoginName)",
      UniversalLink :true
    });
  } catch(e) {
    alert(e.message);
  }
}

function securusCheckSubscStatus(id){
  $.ajax({
    type: 'post',
    url: 'https://' + securus_shop_id + '.securus.bz/api/subscription_status',
    data : { customer_id : id },
    dataType    : "json",      
  }).done(function(data, textStatus, jqXHR){
    if( data && data.errors){
      console.log(data.errors.join('\n'));
      return;
    }
    if( data && data.error){
      console.log(data.error);
      return;
    }
    if( data ){
      if( data.result < 1 ){
        $('#div_subsc_warning').show();	
      }      		
    }
  }).fail(function(data, textStatus, errorThrown){
    console.log(textStatus);  
  }).always(function(data, textStatus, returnedObject){
  }); 
}

function securusCheckShowBeBut(id){
  $.ajax({
    type: 'post',
    url: 'https://' + securus_shop_id + '.securus.bz/api/is_show_be_but',
    data : { customer_id : id },
    dataType : "json",
  }).done(function(data, textStatus, jqXHR){
    if( data && data.errors){
      console.log(data.errors.join('\n'));
      return;
    }
    if( data && data.error){
      console.log(data.error);
      return;
    }
    if( data ){
      console.log(data.result);
      if( data.result ){
        $('#but-beapp').show();	
      }      		
    }
  }).fail(function(data, textStatus, errorThrown){
    console.log(textStatus);  
  }).always(function(data, textStatus, returnedObject){
  }); 
}
*/

function securusCheckShowLibraryBut(id){
  $.ajax({
    type: 'post',
    url: 'https://' + securus_shop_id + '.securus.bz/api/is_show_library_but',
    data : { shop : securus_shop_id, customer_id : id },
    dataType    : "json",      
  }).done(function(data, textStatus, jqXHR){
    if( data && data.errors){
      console.log(data.errors.join('\n'));
      return;
    }
    if( data && data.error){
      console.log(data.error);
      return;
    }
    if( data ){
      console.log(data.result);
      if( data.result ){
        $('#but-view-library-ctrl').show();	
      }      		
    }
  }).fail(function(data, textStatus, errorThrown){
    console.log(textStatus);  
  }).always(function(data, textStatus, returnedObject){
  }); 
}

function securusButViewLibraryClick(){
  var url = 'https://' + securus_shop_id + '.securus.bz/my-library';
  var inputs = "<input type='hidden' name='customer_id' value='" + $(this).data('customerid') + "'>";
  $("body").append('<form action="'+url+'" method="post" id="post">'+inputs+'</form>');
  $("#post").submit();
  return false
}

function securusClickWebViewer(id, type) {
  try {
    let params = {
      shop : securus_shop_id,
      contents_id: id,
    };
    if (type.toUpperCase() == 'PDF') endpoint = "viewer-pdf-brdg";
    if (type.toUpperCase() == 'EPUB') endpoint = "viewer-epub-brdg";
    window.open('', 'bookend_viewer_' + params.contents_id);
    $.ajax({
      type: 'post',
      url: 'https://' + securus_shop_id + '.securus.bz/api/' + endpoint,
      data: params,
      dataType: "json",
    }).done(function (data, textStatus) {
      if (data && data.errors) {
        alert('ビューアの起動に失敗しました\n' + data.errors.join('\n'));
        return;
      }
      if (data && data.error) {
        alert('ビューアの起動に失敗しました\n' + data.error);
        return;
      }
      if (data) {
        window.open(data.url, 'bookend_viewer_' + params.contents_id);
      }
    }).fail(function (data, textStatus, errorThrown) {
      if (errorThrown == 'Unauthorized') {
        alert('前回動作から時間が経ちましたので、ページを再読み込みしてください');
      } else {
        alert('通信エラーが発生しました');
      }
    });
  } catch(e) {
    alert(e.message);
  }
}
